<template>
  <div>
    <Widget2></Widget2>
  </div>
</template>

<script>
import Widget2 from "@/view/pages/expend/Widget2";
export default {
  name: "expend",
  components: {
    Widget2,
  },
};
</script>

<style scoped></style>
